<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <path
      d="M14.791 9.50244C13.5009 9.50244 12.4478 10.5555 12.4478 11.8456V28.1656C12.4478 29.4558 13.5009 30.5088 14.791 30.5088H25.2128C26.503 30.5088 27.5633 29.4558 27.5633 28.1656V11.8456C27.5633 10.5555 26.503 9.50244 25.2128 9.50244H14.791ZM14.791 10.2527H25.2128C26.0975 10.2527 26.8116 10.961 26.8116 11.8456V28.1656C26.8116 29.0503 26.0975 29.757 25.2128 29.757H14.791C13.9063 29.757 13.1981 29.0503 13.1981 28.1656V11.8456C13.1981 10.961 13.9063 10.2527 14.791 10.2527ZM18.9879 14.3793C18.4939 14.3793 18.096 14.8185 18.1482 15.3098L18.8633 22.0169C18.9147 22.5009 19.3306 22.8756 19.8173 22.8756H20.3771C20.8648 22.8756 21.2738 22.4971 21.3134 22.011L21.863 15.3039C21.903 14.8122 21.5035 14.3793 21.0101 14.3793H18.9879ZM18.9879 15.0768H21.0101C21.1068 15.0768 21.1733 15.1533 21.1654 15.2497L20.6218 21.9524C20.6111 22.0831 20.5082 22.1781 20.3771 22.1781H19.8173C19.6811 22.1781 19.5694 22.082 19.555 21.9465L18.8399 15.238C18.8302 15.1471 18.8965 15.0768 18.9879 15.0768ZM19.2971 23.6815C19.0381 23.695 18.8281 23.9135 18.8281 24.1754V25.1293C18.8281 25.3997 19.0516 25.6305 19.322 25.6305H20.6877C20.958 25.6305 21.183 25.3997 21.183 25.1293V24.1754C21.183 23.905 20.958 23.6815 20.6877 23.6815C20.2252 23.6815 19.7576 23.6815 19.2971 23.6815ZM19.5257 24.3791H20.4855V24.933H19.5257L19.5257 24.3791Z"
      fill="#040325"
      stroke="#040325"
      stroke-width="0.5"
    />
  </svg>
</template>
